import { addNotification } from 'root/actions';
import notifications, { NOTIFICATION_IDS } from 'root/data/NotificationsData';
import getUnsplash from '../service';
import { EDITORIAL_SLUG, HOME_PAGE_PARAMS } from '../data/consts';
import { selectSelectedAsset } from '../selectors';
import { types } from './';

export const retrieveHomePageAssets = async (dispatch, getState, dispatcher) => {
  const service = getUnsplash();
  dispatcher(types.SET_RESULTS_RETRIEVE_START);

  const results = await service.getHomeAssets(HOME_PAGE_PARAMS);
  if (results?.error) {
    addNotification(notifications[NOTIFICATION_IDS.ERROR], dispatch);
  } else {
    dispatcher(types.SET_HOME_PAGE_RESULTS_RETRIEVE_SUCCESS, results);
  }
  dispatcher(types.SET_RESULTS_RETRIEVE_END);
};

export const retrieveAssets = async (payload, dispatch, getState, dispatcher) => {
  const service = getUnsplash();
  const state = getState();

  const currentPage = state.unsplash.list.page;
  const newPage = payload.page || 1;
  let { slug, searchPhrase, orderBy } = state.unsplash;

  if (payload.slug || payload.slug === null) {
    slug = payload.slug;
    searchPhrase = '';
  }
  if (payload?.searchPhrase) {
    slug = undefined;
    searchPhrase = payload.searchPhrase;
  }
  orderBy = payload.orderBy || orderBy;
  const page = newPage > currentPage ? newPage : 1;

  const searchParams = {
    slug,
    searchPhrase,
    page,
    orderBy,
    filters: {
      ...state.unsplash.filters,
      ...payload.filters,
    },
  };

  dispatcher(types.SET_RESULTS_RETRIEVE_START);
  dispatcher(types.SET_SEARCH_PARAMS, searchParams);

  if (page === 1) {
    dispatcher(types.CLEAR_RESULTS);
  }

  const results = slug && slug !== EDITORIAL_SLUG ? await service.getTopics(searchParams, page) : await service.getSearchResults(searchParams, page);
  if (results?.error) {
    addNotification(notifications[NOTIFICATION_IDS.ERROR], dispatch);
  } else {
    dispatcher(types.SET_RESULTS_RETRIEVE_SUCCESS, results);
  }
  dispatcher(types.SET_RESULTS_RETRIEVE_END);
};

export const downloadAssetAndUpload = async (payload, dispatch, getState, dispatcher) => {
  const service = getUnsplash();
  const state = getState();
  const { selectedAsset, selectedFormat } = selectSelectedAsset(state);

  dispatcher(types.UPLOAD_START);
  const url = await service.download(selectedAsset.download_location, selectedFormat.height);
  dispatcher(types.UPLOAD_END);
  dispatcher(types.CLEAR_FORMAT);

  dispatch(payload.uploadAsset({ files: [url] }));
};

export const retrieveAssetDetails = async (payload, dispatch, getState, dispatcher) => {
  const service = getUnsplash();
  const result = await service.retrieveAssetDetails(payload.id);

  if (!result?.error) {
    dispatcher(types.RETRIEVE_ASSET_DETAILS_SUCCESS, result);
  }
};
